// extracted by mini-css-extract-plugin
module.exports = {"modal":"style_modal__2XwOh","modalContent":"style_modalContent__3Jg5a","modalBtn":"style_modalBtn__3dnoB"};